import React from 'react';
import { SvgIcon } from '@mui/material';

const CrossIcon = ({ ...props }) => (
    <SvgIcon
        {...props}
        aria-label="Close Dialog"
        width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M27.5582 23.9992L35.2519 16.3377C35.7501 15.8413 36 15.1909 36 14.5404C36 13.89 35.7501 13.2395 35.2519 12.7432C34.2555 11.7523 32.642 11.7523 31.6456 12.7432L23.9996 20.3607L16.3535 12.7432C15.3572 11.7523 13.7436 11.7523 12.7473 12.7432C11.7509 13.7358 11.7509 15.345 12.7473 16.3377L20.4392 23.9992L12.7473 31.6623C11.7509 32.655 11.7509 34.2642 12.7473 35.2568C13.7436 36.2477 15.3572 36.2477 16.3535 35.2568L23.9996 27.6393L31.6456 35.2568C32.642 36.2477 34.2555 36.2477 35.2519 35.2568C35.7501 34.7605 36 34.11 36 33.4596C36 32.8091 35.7501 32.1587 35.2519 31.6623L27.5582 23.9992Z" fill="black"/>
    </SvgIcon>

);

export default CrossIcon;
